// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__2YYIA","header":"styles_header__3hxB6","back":"styles_back__2HHVd","title":"styles_title__vF6Un","content":"styles_content__1voj6"};